export const AllowMeErrorReasons = {
  initMissingKey: 'allowme_init_missing_key',
  initFailed: 'allowme_init_failed',
  initException: 'allowme_init_exception',
  collectException: 'allowme_collect_exception',
  collectFailed: 'allowme_collect_failed',
  collectEmpty: 'allowme_collect_empty',
  fingerprintNotSent: 'allowme_fingerprint_not_sent',
  fingerprintUnexpected: 'allowme_fingerprint_unexpected',
};

export const AllowMeErrorPhases = {
  bootstrapInit: 'bootstrap_init',
  loginCollect: 'login_collect',
  login: 'login',
};

export const AllowMeErrorOutcomes = {
  initDisabledCollection: 'init_disabled_collection',
  loginContinuedWithoutFingerprint: 'login_continued_without_fingerprint',
};

export const AllowMeErrorCauseReasons = {
  initNotSucceeded: 'init_not_succeeded',
  collectEmpty: 'collect_empty',
  collectFailed: 'collect_failed',
  exception: 'exception',
  timeout: 'timeout',
};

export const AllowMeProcessSteps = {
  sdkLoad: 'sdk_load',
  sdkInit: 'sdk_init',
  sdkCollect: 'sdk_collect',
  loginSend: 'login_send',
};

export const AllowMeProcessStepLabels = {
  sdk_load: 'Carregamento do script AllowMe (CDN)',
  sdk_init: 'Setup da SDK (Alwm.init)',
  sdk_collect: 'Coleta do fingerprint (Alwm.collect)',
  login_send: 'Envio do login sem fingerprint',
};

export const ALLOWME_EXPECTED_KEY_MIN_LENGTH = 16;

export const AllowMeLikelyCauses = {
  apiKeyMissing: 'api_key_missing',
  apiKeyTooShort: 'api_key_too_short',
  sdkCdnUnreachable: 'sdk_cdn_unreachable',
  sdkSetupRejected: 'sdk_setup_rejected',
  sdkInitTimeout: 'sdk_init_timeout',
  sdkInitException: 'sdk_init_exception',
  collectTimeoutInvalidKey: 'collect_timeout_possible_invalid_key',
  collectTimeoutHang: 'collect_timeout_sdk_hang',
  allowmeAuthRejected: 'allowme_http_auth_rejected',
  allowmeBackendError: 'allowme_http_backend_error',
  sdkCollectRejected: 'sdk_collect_rejected',
  collectEmpty: 'collect_empty',
  sdkApiMissing: 'sdk_api_missing',
  sdkCollectException: 'sdk_collect_exception',
  initNotSucceeded: 'init_not_succeeded',
};

export const AllowMeLikelyCauseLabels = {
  api_key_missing: 'API key AllowMe vazia',
  api_key_too_short: 'API key AllowMe truncada ou incompleta',
  sdk_cdn_unreachable: 'Falha ao carregar o script da AllowMe (CDN)',
  sdk_setup_rejected: 'SDK rejeitou o setup (Alwm.init)',
  sdk_init_timeout: 'Timeout no setup (Alwm.init)',
  sdk_init_exception: 'Exceção no setup (Alwm.init)',
  collect_timeout_possible_invalid_key:
    'Timeout no collect após init ok — chave inválida, ambiente errado ou domínio não liberado',
  collect_timeout_sdk_hang: 'Timeout no collect — SDK não retornou',
  allowme_http_auth_rejected: 'Backend AllowMe recusou autenticação (HTTP 401/403)',
  allowme_http_backend_error: 'Backend AllowMe retornou erro HTTP',
  sdk_collect_rejected: 'SDK recusou a coleta (retorno error:)',
  collect_empty: 'Collect retornou vazio',
  sdk_api_missing: 'Alwm.collect indisponível após o setup',
  sdk_collect_exception: 'Exceção na coleta do fingerprint',
  init_not_succeeded: 'Setup não concluiu; collect nem foi chamado',
};

export const inferAllowMeLikelyCause = ({
  apiKeyLength = 0,
  kind,
  httpStatus,
} = {}) => {
  if (!apiKeyLength) {
    return AllowMeLikelyCauses.apiKeyMissing;
  }
  if (apiKeyLength < ALLOWME_EXPECTED_KEY_MIN_LENGTH) {
    return AllowMeLikelyCauses.apiKeyTooShort;
  }
  if (httpStatus === 401 || httpStatus === 403) {
    return AllowMeLikelyCauses.allowmeAuthRejected;
  }
  if (typeof httpStatus === 'number' && httpStatus >= 400) {
    return AllowMeLikelyCauses.allowmeBackendError;
  }
  switch (kind) {
    case 'load':
      return AllowMeLikelyCauses.sdkCdnUnreachable;
    case 'init_rejected':
      return AllowMeLikelyCauses.sdkSetupRejected;
    case 'init_timeout':
      return AllowMeLikelyCauses.sdkInitTimeout;
    case 'init_exception':
      return AllowMeLikelyCauses.sdkInitException;
    case 'init_not_succeeded':
      return AllowMeLikelyCauses.initNotSucceeded;
    case 'timeout':
      return AllowMeLikelyCauses.collectTimeoutInvalidKey;
    case 'native_error':
      return AllowMeLikelyCauses.sdkCollectRejected;
    case 'empty':
      return AllowMeLikelyCauses.collectEmpty;
    case 'missing_api':
      return AllowMeLikelyCauses.sdkApiMissing;
    default:
      return AllowMeLikelyCauses.sdkCollectException;
  }
};

export const buildAllowMeCorrectionHint = (likelyCause, { apiKeyLength, ambiente, sdkUrl } = {}) => {
  switch (likelyCause) {
    case AllowMeLikelyCauses.apiKeyMissing:
      return 'ALLOWME_KEY vazia. Preencher keyHlg/keyPrd no vars do parceiro.';
    case AllowMeLikelyCauses.apiKeyTooShort:
      return `API key com ${apiKeyLength} caracteres (AllowMe costuma ter ~40). Chave truncada no vars impede a coleta na web mesmo com Alwm.init "ok". Restaurar keyHlg/keyPrd completa.`;
    case AllowMeLikelyCauses.sdkCdnUnreachable:
      return `Não carregou ${sdkUrl || 'o script CDN'}. Verificar rede, adblock e se o ambiente ${ambiente || ''} aponta para a URL certa.`;
    case AllowMeLikelyCauses.sdkSetupRejected:
      return 'Alwm.init recusou a chave. Conferir se a key é do ambiente certo (hlg vs prd) e se o domínio está liberado na AllowMe.';
    case AllowMeLikelyCauses.sdkInitTimeout:
      return 'Alwm.init não respondeu. Verificar rede até o backend AllowMe e a chave de ambiente.';
    case AllowMeLikelyCauses.collectTimeoutInvalidKey:
      return 'Na web, chave inválida / de outro ambiente / domínio não allowlisted quase nunca quebra o init: o collect que trava. Conferir keyHlg vs stage-sdk e keyPrd vs sdk-js, e o domínio do IB na AllowMe.';
    case AllowMeLikelyCauses.allowmeAuthRejected:
      return 'HTTP 401/403 no backend AllowMe: chave inválida ou ambiente trocado (hlg vs prd).';
    case AllowMeLikelyCauses.allowmeBackendError:
      return 'Backend AllowMe respondeu erro HTTP durante a coleta. Verificar status em sdk_network e abrir chamado na AllowMe se persistir.';
    case AllowMeLikelyCauses.sdkCollectRejected:
      return 'Alwm.collect devolveu error:. Usar error_message como causa da SDK; conferir chave e domínio.';
    case AllowMeLikelyCauses.initNotSucceeded:
      return 'Corrigir a falha de setup (origin_process_step / allowme_last_init_diagnostic) antes de investigar o login.';
    default:
      return undefined;
  }
};
